// Domain creation order V1; 2026-11-01 21:45:20 CST; parent af634cfe495a390f7c420624e9dad97c0cccb750.
export function creationTimestamp(value?: string): number {
 if (!value) return -Infinity;
 const normalized = value.trim().replace(' ', 'T');
 const instant = Date.parse(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalized) ? normalized : normalized + 'Z');
 return Number.isFinite(instant) ? instant : -Infinity;
}
export function newestDomainFirst(a: {id:number;createdAt?:string}, b: {id:number;createdAt?:string}) {
 const left=creationTimestamp(a.createdAt),right=creationTimestamp(b.createdAt);
 return left===right ? b.id-a.id : left>right ? -1 : 1;
}
export function creationTimeBeijing(value?: string): string {
 const time=creationTimestamp(value);
 if (!Number.isFinite(time)) return '暂无数据';
 const parts=new Intl.DateTimeFormat('zh-CN',{timeZone:'Asia/Shanghai',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(time);
 const part=(key:string)=>parts.find(item=>item.type===key)?.value;
 return `${part('year')}-${part('month')}-${part('day')} ${part('hour')}:${part('minute')}:${part('second')}`;
}
